import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Componentes
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';

// Páginas
import Home from './pages/Home';
import ChatAdmin from './pages/ChatAdmin';
import SiteAdmin from './pages/SiteAdmin';
import { SiteContentProvider } from './context/SiteContentContext';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = ['/chat-admin', '/site-admin'].includes(location.pathname);

  return (
    <>
      {!isAdminRoute && <Navbar />}

      <Routes>
        <Route path="/chat-admin" element={<ChatAdmin />} />
        <Route path="/site-admin" element={<SiteAdmin />} />
        <Route path="/" element={<Home />} />
      </Routes>

      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <SiteContentProvider>
      <Router>
        <AppContent />
      </Router>
    </SiteContentProvider>
  );
}

export default App;
